import React from "react";

type TOwnProps = {
  width?: string;
  height?: string;
};

const Logo = (props: TOwnProps) => {
  const { width = 80, height = 80 } = props;
  return (
    <img
      src="/assets/images/logo-header.jpeg"
      alt="loh-logo"
      width={width}
      height={height}
    />
  );
};

export default Logo;
